"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("../classnames"));
var sizes = ["xs", "sm", "md", "lg", "xl"];
var getItemClassName = function (className, sizeProps) {
    var classList = classnames_1.default("chq-grid--item", className);
    sizes.forEach(function (size) {
        if (sizeProps[size]) {
            classList = classList + " chq-grid--" + size + "-" + sizeProps[size];
        }
        else if (sizeProps[size] === false) {
            classList = classList + " chq-grid--" + size + "-hid";
        }
    });
    return classList;
};
// Inner div necessary per https://github.com/philipwalton/flexbugs#flexbug-7
var GridItem = function (_a) {
    var children = _a.children, className = _a.className, sizeProps = __rest(_a, ["children", "className"]);
    return (react_1.default.createElement("div", { className: getItemClassName(className, sizeProps) },
        react_1.default.createElement("div", { className: "chq-grid--item--inner" }, children)));
};
var Grid = function (_a) {
    var children = _a.children, className = _a.className;
    return (react_1.default.createElement("div", { className: classnames_1.default("chq-grid", className) }, children));
};
Grid.Item = GridItem;
exports.default = Grid;
